import { createReducer } from "redux-create-reducer";

import { GET_ALL_SCORE_CARDS_RISK_FACTORS_BY_TYPE } from "../types/getAllScoreCardRiskFactorsByType";

const initialState = {
  data: {},
  isLoading: false,
};

const getAllScoreCardsRiskFactorsByTypeReducer = createReducer(initialState, {
  [GET_ALL_SCORE_CARDS_RISK_FACTORS_BY_TYPE.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_ALL_SCORE_CARDS_RISK_FACTORS_BY_TYPE.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_ALL_SCORE_CARDS_RISK_FACTORS_BY_TYPE.FULFILLED]: (
    state,
    { payload }
  ) => ({
    ...state,
    data: payload.data,
    isLoading: false,
  }),
});

export default getAllScoreCardsRiskFactorsByTypeReducer;



// WEBPACK FOOTER //
// ./src/features/score-card/reducers/getAllScoreCardsRiskFactorsByTypeReducer.js